import React from 'react';
import ReactDOM from 'react-dom';
import styles from './AddTicketModal.module.css';

function DeleteBucketModal({ isOpen, onClose, onConfirm }) {
  const handleDeleteConfirmAction = () => {
    onConfirm();
    onClose();
  };

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className={styles.modalOverlay} style={{
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
    }}>
      <div className={styles.modalContent} style={{ padding: '15px', width: '400px' }}>
        <h2 style={{ fontSize: '1.5em', marginBottom: '10px', textAlign: 'center' }}>Delete Bucket</h2>
        <p style={{ fontSize: '1em', marginBottom: '15px', textAlign: 'center' }}>
          Are you sure you want to delete this bucket? <br />
          This action cannot be undone.
        </p>
        <div className={styles.buttonGroup} style={{ display: 'flex', justifyContent: 'space-between', gap: '10px' }}>
          <button className={styles.secondaryButton} style={{ padding: '8px 12px' }} onClick={onClose}>
            Cancel
          </button>
          <button
            className={styles.primaryButton}
            style={{
              padding: '8px 12px',
              backgroundColor: 'red',
              color: 'white',
              transition: 'background-color 0.3s ease',
            }}
            onClick={handleDeleteConfirmAction}
            onMouseEnter={(e) => (e.target.style.backgroundColor = '#cc0000')}
            onMouseLeave={(e) => (e.target.style.backgroundColor = 'red')}
          >
            Delete
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}

export default DeleteBucketModal;
